module.exports = __webpack_public_path__ + "static/CM_FM-df31991ac60517ac8e5ccca8b6e20110.jpg";